import { z } from "zod/v4";
import { ventaFormSchema } from "@/features/inventario/ventas/components/venta-form";

// Schema extendido para venta con campos de Facturación Electrónica
// Nota: dEst, dPunExp y cMoneOpe se agregan dinámicamente desde config antes de enviar
export const ventaConFEFormSchema = ventaFormSchema.extend({
  // Campos FE adicionales
  iTipTra: z.number().default(1),
  iTipEmi: z.number().default(1),
  iIndPres: z.number().default(1),
  dCondTiCam: z.number().default(1),
  dDesIndPres: z.string().optional(),
  informacionAdicional: z.string().optional(),
  dTiCam: z.number().optional()
});
